import styled from '@emotion/styled';
import { usePolicyText } from '@/hooks/usePolicyText';

const Desc = styled.section`
  padding-top: 12px;
  padding-bottom: 0;
  text-align: center;
`;

const First = styled.div`
  font-weight: 600;
  font-size: 17px;
  letter-spacing: 0.87px;
  text-align: center;
  color: #141414;
  margin-bottom: 12px;
`;

const Second = styled.div`
  font-size: 14px;
  letter-spacing: 0.87px;
  text-align: center;
  margin-bottom: 20px;
`;

const Third = styled.div`
  font-size: 14px;
  letter-spacing: 0.87px;
  text-align: center;
  margin-bottom: 20px;
`;

export function V1Desc() {
  const {
    trialDays,
    billingFrequencyLabel,
    recurringPriceFormatted,
    trialPriceFormatted,
  } = usePolicyText();

  return (
    <Desc>
      <First>
        Unlock full access to premium VPN and AI-powered cleaning tools — just
        {' '}
        {trialPriceFormatted}
        {' '}
        for
        {' '}
        {trialDays}
        {' '}
        days.
      </First>
      <Second>
        Enjoy encrypted browsing, smart threat detection, IP protection, and intelligent device
        cleanup. Cancel anytime with zero hassle — full refund if you're not fully satisfied.
      </Second>
      <Third>
        Your Apple account will be charged upon purchase confirmation and at the start of each
        renewal period.
        {' '}
        {trialPriceFormatted}
        {' '}
        covers the introductory trial. After that the
        subscription automatically renews at
        {' '}
        {recurringPriceFormatted}
        {' '}
        per
        {' '}
        {billingFrequencyLabel}
        ,
        unless canceled at least 24 hours before the current period ends. Cancellation takes effect
        after the last day of your current subscription, reverting you to the free plan. Any unused
        portion of the introductory offer will be forfeited if you switch to another premium
        subscription during the trial.
      </Third>
    </Desc>
  );
}
